import ChallengeCurationCreateOrEdit from './ChallengeCurationCreateOrEdit';

export default ChallengeCurationCreateOrEdit;
